// Nome + selos À DIREITA do nome — a regra única do app para onde os selos
// aparecem (post, perfil, busca, ranking, clube, comentário). Ordem: o
// profissional (CRN/CREF) e depois o de Criador Parceiro — a mesma do post e
// do perfil. Selo não vai sobre o avatar: no canto da foto ele brigava com o
// emblema de nível e com a câmera, e em avatar pequeno virava um borrão.
//
// Sem selo, devolve exatamente o elemento que estava ali antes (mesma tag,
// mesma classe): quem não tem selo não ganha nem um <span> a mais. Com selo,
// o nome ganha um invólucro inline-flex; a classe de quem chama continua no
// nome, então tipografia e reticências não mudam.
//
// `selo`: o tipo do selo profissional ('nutri' | 'personal'), como devolve
// `seloDoUsuario(pro)`. `expandir`: para linhas em que o nome tinha
// `flex: 1` para empurrar o que vem depois (pontos, botão). O flex passa para
// o invólucro — o nome encolhe ao próprio texto e os selos ficam colados nele.

import React from 'react';
import cx from '../../design/cx';
import Selo from '../../design/components/Selo/Selo';
import SeloCriador from './SeloCriador';
import SeloPremium from './SeloPremium';
import s from './NomeComSelo.module.scss';

export default function NomeComSelo({
  criador = false,
  premium = false,
  selo = null,
  children,
  className = '',
  expandir = false,
  tamanho = 14,
  as: Tag = 'span',
}) {
  if (!criador && !premium && !selo) return <Tag className={className}>{children}</Tag>;
  return (
    <span className={cx(s.linha, expandir && s.expandir)}>
      <Tag className={cx(className, s.nome)}>{children}</Tag>
      {selo && <Selo tipo={selo} tamanho={tamanho} />}
      {criador && <SeloCriador size={tamanho} glow={false} />}
      {/* Premium (Turbo ou Premium da academia). Criador nunca é assinante,
          então os dois não aparecem juntos na prática. */}
      {premium && !criador && <SeloPremium size={tamanho} glow={false} />}
    </span>
  );
}
